export * from "@vaadin/message-list/vaadin-message.js";
export * from './generated/Message.js';
